<script>

	import { mapState } from 'vuex'

	import Page from '@/containers/Page/Page'
	import RegisterBox from '@/components/RegisterBox/RegisterBox'

	import './style.scss'

	export default {
		name: 'login',
		components: {
			Page,
			RegisterBox,
		},
		data: () => ({
			email: '',
			password: '',
		}),
		created () {
			if (this.isLoggedIn === true) this.$router.push('/')
		},
		computed: {
			...mapState({
				'isLoggedIn': state => state.user.isLoggedIn
			})
		}
	}

</script>

<template>
	<Page class='login'>
		<RegisterBox />
	</Page>
</template>



// WEBPACK FOOTER //
// src/flows/Register/Register.vue